const messages = {
  en: {
    manual: 'User Manual',
    feature: 'Features',
    spec: 'Technical Specs',
    cart: 'Add To Cart',
    home: 'Home',
    booklet: 'About Phone'
  },
  'es-ud': {
    manual: 'Manual de Usuario',
    feature: 'Características',
    spec: 'Especificaciones Técnicas',
    cart: 'Agregar al Carrito',
    home: 'Inicio',
    booklet: 'Acerca de tu Teléfono'
  },
  es: {
    manual: 'Manual de Usuario',
    feature: 'Características',
    spec: 'Especificaciones Técnicas',
    cart: 'Agregar al Carrito',
    home: 'Inicio',
    booklet: 'Acerca de tu Teléfono'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/Specs/messages.js